import bootbox from '../../bootbox.min';

export default {

  data() {
    return {
      bootboxButtons: {
        cancel: {
          label: 'Não',
          className: 'btn-outline-secondary',
        },
        confirm: {
          label: 'Sim',
          className: 'btn-secondary text-white',
        },
      },

      printWithTheme: false,
      printWithoutAdjustments: false,

      dontCallPrintConfirm: false,
    };
  },

  methods: {
    submitForm: _.debounce(function (form) {
      this.$refs[form].submit();
    }, 100),

    printPosters(checkHasPosterId = false) {

      if (checkHasPosterId) {
        const posterId = $('#posterPrint').val();
        if (!posterId) {
          return bootbox.alert('Você deve salvar o cartaz para poder imprimi-lo!');
        }
      }

      if (this.totalPosters === 0) {
        return bootbox.alert('Selecione ao menos um cartaz.');
      }

      const message = 'Tem certeza que deseja imprimir?';
      const form = 'printForm';

      (this.isMagazine)
        ? this.callBootboxPromptMagazine(message, 'Selecione o tipo de papel para impressão', form)
        : this.callBootboxPrompt(message,
              'Imprimir com campanha no fundo', 'Imprimir sem campanha no fundo', form);
    },

    exportPdf() {
      if (this.totalPosters === 0) {
        return bootbox.alert('Selecione ao menos um cartaz.');
      }

      if (!this.onlyPrint) {
        this.printWithTheme = true;
        return this.submitForm('exportForm');
      }

      let vm = this;

      let message = "Para imprimir arquivo PDF, siga os passos abaixo:  <br><br><br>"
          + "1 - Clique no botão imprimir e escolha se a impressão será com ou sem campanha. <br><br>"
          + '2 - Quando o arquivo abrir, clique na opção "Destino", escolha a opção "Salvar como PDF e salve."' + "<br><br>"
          + "3 - Escolha onde o arquivo deverá ser salvo, defina um nome do arquivo e clique novamente em salvar. <br><br>"
          + "4 - Abra o arquivo gerado e faça a impressão. <br><br>";

      return bootbox.alert({
        title: 'Imprimir PDF',
        message: message,
        size: 'large',
        buttons: {
          ok: {
            label: 'Imprimir',
            className: 'btn-secondary text-white',
          },
        },
        callback: function (result) {
          return vm.printPosters();
        }
      });

      // const title = 'Tem certeza que deseja gerar o PDF?';
      //
      // (this.isMagazine && this.onlyPrint)
      //   ? this.callBootboxPromptMagazine(title, 'Selecione o tipo de papel', 'exportForm')
      //   : this.callBootboxPrompt(title,
      //   'Gerar com campanha no fundo', 'Gerar sem campanha no fundo', 'exportForm');
    },

    callBootboxPrompt(title, inputTextTrue, inputTextFalse, form) {
      let vm = this;
      if(this.dontCallPrintConfirm)
        return this.submitForm(form);

      bootbox.prompt({
        title: title,
        closeButton: false,
        buttons: this.bootboxButtons,
        value: this.printWithTheme,
        inputType: 'radio',
        inputOptions: [{text: inputTextTrue, value: true}, {text: inputTextFalse, value: false}],
        callback: function (confirm) {
          if (confirm) {
            vm.printWithTheme = confirm;
            vm.submitForm(form);
          }
        },
      });
    },

    callBootboxPromptMagazine(title, message, form) {
      let vm = this;
      bootbox.prompt({
        title: title,
        message: message,
        closeButton: false,
        buttons: this.bootboxButtons,
        value: this.printWithTheme,
        inputType: 'radio',
        inputOptions: [
          {text: 'Papel sem borda', value: 1},
          {text: 'Papel com borda', value: 0},
        ],
        callback(result) {
          if (!!result) {
            vm.printWithoutAdjustments = +result;
            vm.submitForm(form);
            vm.$root.$emit('print-feedback-form')
          }
        },
      });
    },

    callBootboxConfirm(message, form) {
      let vm = this;
      bootbox.confirm({
        message: message,
        buttons: this.bootboxButtons,
        callback: (confirm) => {
          if (confirm) {
            vm.$refs[form].submit();
          }
        },
      });
    },
  },
};



// WEBPACK FOOTER //
// ./resources/assets/js/components/mixins/PrintPoster.js